import { useState } from "react";
import { Menu } from "lucide-react";
import { Sidebar, MobileSidebar } from "./Sidebar";

export const DashboardLayout = ({ modules, activeLessonId, onSelect, children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div data-testid="dashboard-layout" className="min-h-screen bg-[#050505] flex">
      <Sidebar
        modules={modules}
        activeLessonId={activeLessonId}
        onSelect={onSelect}
      />
      <MobileSidebar
        modules={modules}
        activeLessonId={activeLessonId}
        onSelect={onSelect}
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />

      <main className="flex-1 min-w-0">
        {/* Mobile top bar */}
        <div className="lg:hidden sticky top-0 z-30 flex items-center justify-between px-5 h-16 border-b border-white/[0.06] bg-[#050505]/90 backdrop-blur-xl">
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMobileOpen(true)}
            className="w-9 h-9 rounded-lg bg-white/[0.04] border border-white/10 flex items-center justify-center text-zinc-200"
            aria-label="Open menu"
          >
            <Menu className="w-4 h-4" strokeWidth={1.7} />
          </button>
          <span className="font-heading text-sm text-white font-semibold">
            Kiru<span className="text-[#C5A059]">·</span>beezy
          </span>
          <span className="w-9" />
        </div>

        <div className="px-5 sm:px-8 lg:px-12 py-8 lg:py-12 max-w-6xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};
